export default "__VITE_ASSET__BWPomIMR__"